import { render } from "./DonationStoreTable.vue?vue&type=template&id=54271d4b"
import script from "./DonationStoreTable.vue?vue&type=script&lang=js"
export * from "./DonationStoreTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__